import React, { useContext } from 'react';
import { FlowContext } from '../../core/flow-engine';
import {
  navigateToProfileAfterLogin,
  navigateToProfileAfterEnablement
} from '../../flows/shared/utils';
import Loader from '../Loader/Loader';

const REDIRECT_TIMEOUT = 4 * 1000;

const makeForcedLoginModal = onRedirect => () => {
  const { appState } = useContext(FlowContext);
  const {
    store: { app, accountType, loadedData }
  } = appState;

  const applicationID = app?.profileApplicationID;
  const {
    guestUserApponFile = false,
    registeredOnlyWithAgreements = false,
    enabled = false
  } = loadedData;

  const shouldRouteUserToEnablement = registeredOnlyWithAgreements && !enabled;

  if (!guestUserApponFile) {
    setTimeout(() => onRedirect(applicationID), REDIRECT_TIMEOUT);
  } else if (guestUserApponFile && shouldRouteUserToEnablement) {
    setTimeout(
      () => navigateToProfileAfterEnablement(accountType),
      REDIRECT_TIMEOUT
    );
  } else {
    setTimeout(
      () => navigateToProfileAfterLogin(accountType),
      REDIRECT_TIMEOUT
    );
  }

  const message = `We've noticed you already have an account with T. Rowe Price. 
    Please log in using your existing user name and password. 
    If you've forgotten your user name or password, reset your login credentials.`;

  return <Loader secondaryMessage={message} />;
};

export default makeForcedLoginModal;
